import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { AppVersionViewModel } from "../../models/wholesaler-api-models";
@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private http = inject(HttpClient);
  async getLatestAppVersion(): Promise<AppVersionViewModel> {
    try {
      return await firstValueFrom(this.http.get<AppVersionViewModel>(`lookup/appversion`, {responseType: 'json'}));
    } catch (error) {
      throw new Error('Something went wrong, please try again');
    }
  }
}